import { render, staticRenderFns } from "./wxCallback.vue?vue&type=template&id=7f8c243a"
import script from "./wxCallback.vue?vue&type=script&lang=js"
export * from "./wxCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports